const en_dashboard = {
    search: { title: "Search", placeholder: "Company ID" },
    label: {
        whs: "My Warehouse",
        whs_req: "Warehouse Requests",
        delivery_last: "Recent Deliveries",
        itemin_last: "Recent Incoming Goods",
        item_best_sell: "Best-Selling Items",
        most_trans_cus: "Customers With the Most Transactions",

        look_all: "Look All",
    },
}

export default en_dashboard;